/**
 * Questo file definisce il componente LoadingSpinner.
 * - È un componente riutilizzabile che mostra un overlay a schermo intero con
 * uno spinner di caricamento e un messaggio personalizzabile.
 * - Viene utilizzato per dare un feedback visivo all'utente durante le operazioni
 * asincrone, come le chiamate API, impedendo interazioni con la pagina sottostante.
 * - Lo stile è gestito dal file CSS associato 'LoadingSpinner.css'.
 */

import React from 'react';
import './LoadingSpinner.css';

/**
 * Componente funzionale LoadingSpinner.
 * - Mostra un indicatore di caricamento centrato su un overlay semitrasparente.
 *
 * @param {object} props - Le props del componente.
 * @param {string} [props.message="Operazione in corso..."] - Il messaggio di testo da visualizzare sotto lo spinner.
 * @returns {React.ReactElement} - Il JSX che renderizza l'overlay di caricamento.
 */
const LoadingSpinner = ({ message = "Operazione in corso..." }) => {
    return (
        // 'loading-overlay': div che copre l'intera viewport.
        // Lo stile (posizione fissa, z-index, sfondo) è definito nel CSS.
        <div className="loading-overlay">
            {/* 'loading-content': contenitore per centrare lo spinner e il messaggio. */}
            <div className="loading-content text-center">
                {/* Spinner di Bootstrap. 'spinner-border' crea l'animazione di rotazione. */}
                <div className="spinner-border text-primary mb-3" role="status">
                    {/* 'visually-hidden' è per l'accessibilità: fornisce un testo per gli screen reader. */}
                    <span className="visually-hidden">Loading...</span>
                </div>
                {/* Messaggio visualizzato sotto lo spinner. */}
                {/* Il testo è dinamico, basato sulla prop 'message'. */}
                <h5 className="loading-message">{message}</h5>
            </div>
        </div>
    );
};

// Esporta il componente per poterlo utilizzare in altre parti dell'applicazione.
export default LoadingSpinner;